import { ApiService } from './constant.services'
/* models */
import {
    currentLocale,
    currentLocaleResponse,
    currentPriceResponse,
} from '@models'

export const currentConvert = async ({ from, to, amount }: currentLocale) => {
    try {
        const response = await ApiService.post<currentLocaleResponse>(
            'currency/locale/convert',
            { from, to, amount }
        )

        return response.data.data
    } catch (error) {
        return error
    }
}

export const currentPrice = async (symbol : string) => {
    try {
        const response = await ApiService.get<currentPriceResponse>(
            `currency/crypto/price/${symbol}`
        )

        return response.data.data
    } catch (error) {
        return error
    }
}

export const currentLocalPrice = async (currency: string) => {
    try {
        const response = await ApiService.get<currentLocaleResponse>(
            `currency/locale/price/${currency}`
        )

        return response.data.data
    } catch (error) {
        return error
    }
}
